import InputSlider from '@/components/sections/builder/settings/input-slider';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ThemeVariantPillType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';
import InputTab from '@/components/sections/builder/settings/input-tab';

export const DEFAULT_THEME_VARIANT_PILL = {
  style: 'pills',
  borderThickness: 1,
  borderOpacity: 100,
  borderCornerRadius: 4,
  shadowOpacity: 0,
  shadowHorizontalOffset: 0,
  sahdowVerticalOffset: 4,
  shadowBlur: 5,
};

export default function ThemeVariantPillSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const variantPill: ThemeVariantPillType =
    builder.theme?.variantPill || DEFAULT_THEME_VARIANT_PILL;

  const setLayout = (newVariantPill: Partial<ThemeVariantPillType>) => {
    builder.setTheme({
      variantPill: { ...variantPill, ...newVariantPill },
    });
  };

  return (
    <div>
      <div className='mb-2'>Color scheme</div>
      <SchemeSetting
        value={variantPill.colorScheme}
        onChange={(theme) => setLayout({ colorScheme: theme })}
      />
      <div className='mt-1 text-xs'>
        To edit all your theme&apos;s colors, go to your color theme settings.
      </div>
      <h3 className='mb-2 mt-4 font-bold'>Border</h3>
      <InputSlider
        label='Thickness'
        value={variantPill.borderThickness}
        max={12}
        min={0}
        onChange={(val) => setLayout({ borderThickness: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Opacity'
        value={variantPill.borderOpacity}
        max={100}
        min={0}
        onChange={(val) => setLayout({ borderOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Corner Radius'
        value={variantPill.borderCornerRadius}
        max={40}
        min={0}
        onChange={(val) => setLayout({ borderCornerRadius: val })}
        rightContent={<div>px</div>}
      />
      <h3 className='mb-2 mt-4 font-bold'>Shadow</h3>
      <InputSlider
        label='Opacity'
        value={variantPill.shadowOpacity}
        max={100}
        min={0}
        onChange={(val) => setLayout({ shadowOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Horizontal Offset'
        value={variantPill.shadowHorizontalOffset}
        max={12}
        min={-12}
        onChange={(val) => setLayout({ shadowHorizontalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical Offset'
        value={variantPill.sahdowVerticalOffset}
        max={12}
        min={-12}
        onChange={(val) => setLayout({ sahdowVerticalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Shadow Blur'
        value={variantPill.shadowBlur}
        max={20}
        min={0}
        onChange={(val) => setLayout({ shadowBlur: val })}
        rightContent={<div>px</div>}
      />
      <div className='mb-4 mt-2 font-bold'>Style</div>
      <InputTab
        grid={2}
        defaultValue={variantPill.style || 'pills'}
        options={[
          { label: 'Dropdown', value: 'dropdown' },
          { label: 'Pills', value: 'pills' },
        ]}
        onChange={(val) => {
          setLayout({ style: val });
        }}
      />
    </div>
  );
}
